import { useContext, useMemo, useCallback } from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Bold,
  copy,
  Body
} from '@panwds/react-ui'
import { CopyIcon } from '@panwds/icons'
import { pick } from 'lodash'
import AppContext from '../../../common/context/AppContext'
import {
  BUTTON_CLOSE,
  BUTTON_COPY,
  LABEL_PRODUCT_INFO,
  ERROR_RESOLUTION_SUBTEXT,
  LINK_SUPPORT_CASE
} from '../../constants/LabelConstants'
import StringTemplate from '../../../common/utils/StringTemplate'

const PICK_KEYS = ['app_id', 'tenant_id', 'csp_tenant_id', 'serial_number', 'tsg_id', 'provisioning_status', 'region', 'provisioning_message']
/**
 * A Modal to display instance detail information
 * @returns {JSX.Element}
 * @constructor
 */
const InstanceDetailModal = ({ closeModal, isOpen, data }) => {

  const { getAppName } = useContext(AppContext)
  const instanceObj = useMemo(() => pick(data, PICK_KEYS), [data])

  const copyData = useCallback(() => {
    copy(JSON.stringify(instanceObj))
  }, [instanceObj])

  return (
    <Modal style={{ top: '50%', '--tw-translate-y': '-50%' }} size='lg' onClose={closeModal} isOpen={isOpen}>
      <ModalHeader title={getAppName(data.app_id)} />
      <ModalBody addClassName='tw-overflow-auto'>
        <Bold>{LABEL_PRODUCT_INFO}</Bold>
        <table style={{ tableLayout: 'fixed', width: '100%' }}>
          <tbody>
            {Object.entries(instanceObj).map(([k, v]) => {
              return (
                <tr key={k}>
                  <td className='tw-align-top'><pre className='tw-m-0'>{k}</pre></td>
                  <td className='tw-align-top' style={{ width: '75%' }}>
                    <pre className='tw-m-0' style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                      {JSON.stringify(v, null, 2)}
                    </pre>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
        <Body addClassName='tw-mt-2 tw-mb-2' size='lg'>{StringTemplate(ERROR_RESOLUTION_SUBTEXT, <a
          href='https://supportcases.paloaltonetworks.com/'
          target='_blank'
          rel='noopener noreferrer'>{LINK_SUPPORT_CASE}</a>)}</Body>
        <Button
          icon={<CopyIcon size='sm' />}
          onClick={copyData}
        >{BUTTON_COPY}</Button>
      </ModalBody>
      <ModalFooter>
        <Button onClick={closeModal} appearance="primary">
          {BUTTON_CLOSE}
        </Button>
      </ModalFooter>
    </Modal >
  )
}

InstanceDetailModal.propTypes = {}
export default InstanceDetailModal

